import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './farmselector.css';

const FarmSelector = ({ selectedFarm, onFarmChange, farms = [] }) => {
  const { t } = useTranslation();

  return (
    <div className="farm-selector-container">
      <Form.Select 
        className="farm-select"
        value={selectedFarm || ''}
        onChange={(e) => onFarmChange(e.target.value)}
      >
        <option value="">{t("farmselector:selectFarm")}</option>
        {farms.map(farm => (
          <option key={farm.id} value={farm.id}>
            {farm.name}
          </option>
        ))}
      </Form.Select>
    </div>
  );
};

export default FarmSelector;